import queryString from 'query-string'
import { usingGet, usingPost, usingDelete } from '@ocean/api'
import {
  ShowType,
  SchedulesTagFilterItems,
  AddSimulatorExerciseScheduleModel,
  UpdateSimulatorExerciseScheduleModel,
} from 'modules/simulatorTrainings/instructor/studentLed/Schedules/types'

export const getListSimulatorExerciseSchedules = (
  filters: SchedulesTagFilterItems,
  exerciseId: Guid
) => {
  const { status, showType } = filters
  const includeOthers = showType.value === ShowType.All
  const period = status.value
  const queryParams = queryString.stringify({ includeOthers, period }, { skipNull: true })
  return usingGet(`SimulatorTrainings/studentLed/${exerciseId}/schedules?${queryParams}`, {
    useProxy: true,
  })
}

export const addSimulatorExerciseSchedule = (params: AddSimulatorExerciseScheduleModel) =>
  usingPost('SimulatorTrainings/AddSimulatorExerciseSchedule', params)

export const updateSimulatorExerciseSchedule = (params: UpdateSimulatorExerciseScheduleModel) =>
  usingPost('SimulatorTrainings/UpdateSimulatorExerciseSchedule', params)

export const deleteSimulatorExerciseSchedule = (scheduleId: Guid) =>
  usingDelete(`SimulatorTrainings/DeleteSimulatorExerciseSchedule?scheduleId=${scheduleId}`)
